import { useSessionTimeRemaining } from "raci-react-library";
import { useBffApiClient } from "../useApiClient";

export const useOnResetExpiry = () => {
  const client = useBffApiClient();
  const { setTimeoutTime } = useSessionTimeRemaining();

  const resetSessionExpiry = async () => {
    const response = await client.resetSessionExpiry();
    const expiry = parseInt(response.result);
    setTimeoutTime(new Date().getTime() + expiry * 1000);
  };
  return resetSessionExpiry;
};

export default useOnResetExpiry;
